import React from 'react'
import PropTypes from 'prop-types'
import {Text as BuilderText} from '@builder.io/sdk-react'

const Text = ({text}) => (
    <div
        className="prose-headings:m-0 prose-headings:mb-2 prose-headings:text-emphasis prose-headings:font-heading prose-headings:font-medium prose-headings:tracking-normal
            prose-h1:text-3xl lg:prose-h1:text-6xl prose-h1:leading-11
            prose-h2:text-2.5xl lg:prose-h2:text-5xl prose-h2:mb-4 prose-h2:leading-11
            prose-h3:text-xl lg:prose-h3:text-4xl prose-h3:leading-10
            prose-h4:text-base lg:prose-h4:text-2xl prose-h4:leading-9
            prose-h5:text-sm lg:prose-h5:text-xl prose-h5:mb-[0.3125rem] prose-h5:leading-9
            prose-h6:text-xs lg:prose-h6:text-base prose-h6:mb-[0.3125rem] prose-h6:leading-9
            prose-ol:ps-8 prose-ol:m-0 prose-ol:mb-4 prose-ol:text-sm prose-ol:list-decimal
            prose-ul:ps-8 prose-ul:m-0 prose-ul:mb-4 prose-ul:text-sm prose-ul:list-disc
            prose-li:p-0 prose-li:m-0 prose-li:mb-[0.6875rem] lg:prose-li:mb-[1.3125rem]
            prose-p:m-0 prose-p:mb-4 prose-p:text-sm leading-normal lg:prose-p:text-base
            prose-a:text-emphasis hover:prose-a:underline active:prose-a:underline focus:prose-a:underline"
    >
        <BuilderText text={text} data-testid="text-BuilderText" />
    </div>
)

Text.propTypes = {
    children: PropTypes.node,
    text: PropTypes.string
}

export const TextDefinition = {
    name: 'Text',
    component: Text,
    override: true,
    shouldReceiveBuilderProps: {
        builderBlock: false,
        builderContext: true
    },
    static: true,
    isRSC: true,
    image: 'https://firebasestorage.googleapis.com/v0/b/builder-3b0a2.appspot.com/o/images%2Fbaseline-text_fields-24px%20(1).svg?alt=media&token=12177b73-0ee3-42ca-98c6-0dd003de1929',
    inputs: [
        {
            name: 'text',
            type: 'html',
            required: true,
            autoFocus: true,
            bubble: true,
            defaultValue: 'Enter some text...'
        }
    ]
}

export default Text
